import {
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import {
	createPlaceholderDismissedResource,
	type PlaceholderTemplateDismissedFlag,
} from './createPlaceholderDismissedResource.tsx';

export const placeholderConfluenceDummyLinkCoUseDismissedResource: RouteResource<PlaceholderTemplateDismissedFlag> =
	createPlaceholderDismissedResource(
		'PLACEHOLDER_CONFLUENCE_DUMMY_LINK_COUSE_DISMISSED',
		'hasDismissedConfluenceDummyLinkCoUse',
		'placeholderConfluenceDummyLinkCoUseDismissedResource',
	);

export function usePlaceholderConfluenceDummyLinkCoUseDismissedResource(): UseResourceHookResponse<PlaceholderTemplateDismissedFlag> {
	return useResource(placeholderConfluenceDummyLinkCoUseDismissedResource);
}
